// Default data type values
export const HYPHEN = '-';
export const NUMBER = 0;
export const PERCENTAGE = 100;
export const STRING = '';
export const UNDEFINED = undefined;
export const WHITESPACE = ' ';